import React from "react";
import { withTheme } from "styled-components";
import CssLoadingEllipses from "../../../AlmeUtilities/Animations/CssLoadingEllipses";
import AlmeLiveChatBannerTemplate from "../../AlmeLiveChatBanner/AlmeLiveChatBannerTemplate";
import { getCurrentAppState, updateAppState } from "../../../AlmeApp/AlmeAppState";
import { updateCurrentHadLiveChatCookieValue } from "../../AlmeLiveChatSurvey/HadLiveChatQualtricsCookie";
export function isBeginLiveChatResponse(response) {
    return !!(response.responseActions && response.responseActions.some(x => x.Name === "LiveChatStart"));
}
const AlmeLiveChatStartResponse = (props) => {
    var _a, _b, _c;
    if (!isBeginLiveChatResponse(props.response)) {
        return null;
    }
    if (props.response.responseActions !== undefined && props.response !== null && props.response.responseActions !== null) {
        const almeAppState = getCurrentAppState();
        almeAppState.liveChatCaseID = props.response.responseActions[0].LiveChatCaseID;
        updateAppState(almeAppState);
    }
    const responseRevision = (props.response.responseRevision).toString();
    let iconColor = "", mainText, subText, icon;
    if (props.response.extensionData.operatorJoined) {
        const repName = props.response.extensionData.operatorName || props.appConfig.liveChatBanner.defaultRepName;
        iconColor = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.info;
        mainText = props.appConfig.liveChatBanner.joined.main.text;
        subText = React.createElement(React.Fragment, null,
            props.appConfig.liveChatBanner.joined.sub.text,
            React.createElement("b", null, repName));
        icon = ["fal", "user-check"];
        updateCurrentHadLiveChatCookieValue("true");
    }
    else if (props.response.didSessionEndAsNotEngaged) {
        iconColor = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.button.background;
        mainText = React.createElement(React.Fragment, null, props.appConfig.liveChatBanner.start.main.text);
        subText = props.response.text;
        icon = ["fal", "user-clock"];
    }
    else {
        iconColor = (_c = props.theme) === null || _c === void 0 ? void 0 : _c.button.background;
        mainText = React.createElement(React.Fragment, null,
            props.appConfig.liveChatBanner.start.main.text,
            props.response.fromHistory
                ? null
                : CssLoadingEllipses());
        subText = props.response.text;
        icon = ["fal", "user-clock"];
    }
    return (React.createElement(AlmeLiveChatBannerTemplate, { iconColor: iconColor, icon: icon, mainText: mainText, subText: React.createElement(React.Fragment, null, subText), responseRevision: responseRevision }));
};
export default withTheme(AlmeLiveChatStartResponse);
